import { InfiniteData } from "@tanstack/react-query";
import camelcaseKeys from "src/utils/camelCaseKeys";
import formatDate from "src/utils/formatDate";

const adaptPublishedForms = (
	data: InfiniteData<CMSPaginatedData<IObservationForm>>
) => {
	const { pageParams, pages } = data;

	const publishedForms: CMSPaginatedData<PublishedForm>[] = pages.map(
		(page) => {
			return {
				count: page.count,
				next: page.next,
				previous: page.previous,
				results: page.results.map((result) => {
					return {
						...camelcaseKeys(result),
						observationQuestions: undefined,
						updatedBy:
							typeof result.updated_by === "object" &&
							result.updated_by !== null
								? result.updated_by.name
								: (result.updated_by ?? null),
						createdAt: formatDate(result.created_at),
						updatedAt: formatDate(result.updated_at)
					};
				})
			};
		}
	);

	return {
		pageParams,
		pages: publishedForms
	};
};

export default adaptPublishedForms;
